var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "popup-overlay" }, [
    _c("div", { staticClass: "popup-content" }, [
      _c("h2", [_vm._v("신청을 취소하시겠습니까?")]),
      _vm._v(" "),
      _c("h4", [
        _vm._v("잔여세션이 남아있지 않을경우, 신청이 불가할 수 있습니다.")
      ]),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "bt-akl-blue large NCACroa_submit",
          staticStyle: { "border-radius": "8px" },
          on: { click: _vm.cancelConfirm }
        },
        [_vm._v("예")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "bt-akl-blue large NCACroa_submit",
          staticStyle: { "border-radius": "8px" },
          on: { click: _vm.popupClose }
        },
        [_vm._v("아니오")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a400ae8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a400ae8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/taola/component/WouldUrideCancelConfrim.vue
// module id = null
// module chunks = 